import { createReducer, on } from '@ngrx/store';
import { initialLoginCodeState, LoginCodeState } from './state';
import {
  clearLoginCode,
  requestSuccess,
  requestError,
  loginCode,
} from './actions';

export const loginCodeReducer = createReducer(
  initialLoginCodeState,
  on(loginCode, (state): LoginCodeState => {
    return { ...state, loading: true };
  }),
  on(requestSuccess, (state, { response }): LoginCodeState => {
    const entity = {
      role: response.user ? response.user.role : null,
      id: response.id,
      ttl: response.ttl,
      type: response.type,
      refreshToken: response.refreshToken,
      createdAt: response.createdAt,
      userID: response.userID,
      user: response.user,
    };
    return {
      ...state,
      error: false,
      loading: false,
      response: entity,
    };
  }),
  on(requestError, (state, { error }): LoginCodeState => {
    return {
      ...state,
      error: error,
      loading: false,
      response: null,
    };
  }),
  on(clearLoginCode, (state): LoginCodeState => {
    return {
      error: false,
      loading: false,
      response: null,
    };
  })
);
